const translations = {
  "en": {
    "Act.": "Act.",
    "Revenue: Est.": "Revenue: Est."
  },
  "zh-tw": {
    "Act.": "實際值",
    "Revenue: Est.": "營收：預估"
  }
};

export default translations;
